import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['textarea']

  connect() {
    this.textareaTarget.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  disconnect() {
    this.textareaTarget.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }
}
